import { FETCH_OFFERS_FAILURE, RESET_SELECTED_OFFER } from 'constants/offers';
import { FETCH_RECURRING_OFFERS_SUCCESS } from 'constants/recurringOffers';
import { SET_LOCALE } from 'constants/ui';
import type { RecurringOffer, RecurringOffersMetadata } from 'models/offer';
import { combineReducers } from 'redux';

type RecurringOffersAction =
  | {
      type: typeof FETCH_RECURRING_OFFERS_SUCCESS;
      payload: {
        entities: {
          offers?: Record<string, RecurringOffer>;
        };
        result: string[];
      };
      metadata: RecurringOffersMetadata;
    }
  | { type: typeof FETCH_OFFERS_FAILURE }
  | { type: typeof RESET_SELECTED_OFFER | typeof SET_LOCALE };

export const byId = (state = {}, action: RecurringOffersAction) => {
  switch (action.type) {
    case FETCH_RECURRING_OFFERS_SUCCESS:
      const { entities: { offers = {} } = {} } = action.payload;

      return offers;
    case FETCH_OFFERS_FAILURE:
      return {};
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: RecurringOffersAction) => {
  switch (action.type) {
    case FETCH_RECURRING_OFFERS_SUCCESS:
      const { result: offerIds = [] } = action.payload;
      return offerIds;
    case FETCH_OFFERS_FAILURE:
      return [];
    default:
      return state;
  }
};

const didInvalidate = (state = false, action: RecurringOffersAction) => {
  switch (action.type) {
    case RESET_SELECTED_OFFER:
    case SET_LOCALE:
    case FETCH_OFFERS_FAILURE:
      return true;
    case FETCH_RECURRING_OFFERS_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const metadata = (state = {}, action: RecurringOffersAction) => {
  switch (action.type) {
    case FETCH_RECURRING_OFFERS_SUCCESS:
      const { metadata = {} } = action;

      return metadata;
    case FETCH_OFFERS_FAILURE:
      return {};
    default:
      return state;
  }
};

export const recurringOffers = combineReducers({
  byId,
  ids,
  didInvalidate,
  metadata,
});
